module.exports = __webpack_public_path__ + "static/akebia-logo-white-8cfb43865e4b3df8ede214171bc664a4.svg";